import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UI_CONSTANTS } from '../../shared/constants/claims-ui-constants';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private readonly snackBar: MatSnackBar) {}
  
  public showSnackBar(
    message: string,
    timeout: number,
    styleClass: string
  ): void {
    this.snackBar.open(message, undefined, {
      duration: timeout,
      panelClass: [styleClass],
    });

    setTimeout(() => {
      const containers = document.getElementsByTagName(UI_CONSTANTS.CSS_SELECTORS.SNACK_BAR_CONTAINER);
      if (containers && containers.length > 0 && containers[0]?.parentElement) {
        containers[0].parentElement.style.setProperty('max-height', '0px', 'important');
      }
    });
  }
}